import { useParams } from 'react-router';

import { Alert } from '@app-velocity/ui';

import { RestartIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

import { MessageBus } from '@app-velocity/message-bus';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { useScenarioDetailsContext } from '../../../../hooks/useScenarioDetailsContext';
import { useAIReviewStatusContext } from '../../hooks/useAIReviewStatusContext';
import { useAiChatContext } from '../../../AIChat';

const messageBus = new MessageBus('prototypes');

export const ActionRunAgain = () => {
  const { t } = useI18n();
  const { teamId, workspaceId } = useParams<{ teamId: string, workspaceId: string }>();
  const currentTeam = useCurrentTeamPermissions();

  const { review } = useAIReviewStatusContext();
  const { scenario } = useScenarioDetailsContext();
  const { persona } = useAiChatContext();

  const handleRetry = () => {
    if (!scenario || !scenario.id || !workspaceId || !teamId || !currentTeam) return;

    if (!currentTeam.canRunSimulations(1)) {
      return;
    }

    messageBus.publish('modal:run-again:open', {
      workspaceId,
      teamId,
      scenarioId: scenario.id!,
      shareToken: scenario.shareToken!,
      amount: 1,
      type: 'SINGLE',
      redirect: true,
      persona
    });
  };

  if (
    !review.reviewStatus ||
    !['COMPLETED', 'CANCELED'].includes(review.reviewStatus)
  )
    return null;

  return (
    <Alert.ActionButton status="success" onClick={handleRetry}>
      {t('prototypes:try_again')} <RestartIcon />
    </Alert.ActionButton>
  );
};
